export var BRANCH = 'Branch';
export var INVOICING = 'Invoicing';
